import _classnames from 'clsx';
import PropTypes from 'prop-types';
import React from 'react';
import DropdownItem from './dropdownitem';

/**
 * This functional component maps over the items from the `Dropdown` component's items array to
 * render `DropdownItem` components. When the items in the array are divided into multiple sections,
 * the sections are defined with lines that border each section within the `DropdownPanel`,
 * and a new `DropdownSection` component will render each piece of the items array based on
 * any section information defined by the items.
 */
function DropdownSection({ items, lastSection }) {
  return (
    <li
      className={_classnames('Dropdown__panel__section', {
        'Dropdown__panel__section--last': lastSection,
      })}
    >
      <ul className="Dropdown__panel__list">
        {items.map((item, index) => (
          <DropdownItem
            active={item.active}
            buttonid={item.buttonid}
            caption={item.caption}
            checkboxProps={item.checkboxProps}
            closeAfterClick={item.closeAfterClick}
            closePanel={item.closePanel}
            customItem={item.customItem}
            destructive={item.destructive}
            disabled={item.disabled}
            // domId value corresponds to the itemId hardcoded here and in Dropdown component
            domId={`Section-${item.sectionId}-item-${item.id}`}
            handleRowHover={item.handleRowHover}
            hasCheckbox={item.hasCheckbox}
            header={item.header}
            href={item.href}
            iconLeft={item.iconLeft}
            iconLeftGivenColor={item.iconLeftGivenColor}
            iconRight={item.iconRight}
            id={item.id}
            isLoading={item.isLoading}
            // eslint-disable-next-line react/no-array-index-key
            key={`Section-${item.sectionId}-item-${item.id}-idx-${index}`}
            onClick={item.onClick}
            onCheckboxClick={item.onCheckboxClick}
            small={item.small}
            supportingLabel={item.supportingLabel}
            type={item.type}
          >
            {item.children}
          </DropdownItem>
        ))}
      </ul>
    </li>
  );
}

DropdownSection.propTypes = {
  /**
   * Passed from the `Dropdown` component; if the items array passed to the `Dropdown` component
   * includes multiple `sectionId`s, the array will be filtered by `sectionId` and a `DropdownSection`
   * will be rendered for each `sectionId` defined.
   */
  // eslint-disable-next-line react/forbid-prop-types
  items: PropTypes.array,
  lastSection: PropTypes.bool,
};

DropdownSection.defaultProps = {
  items: [],
  lastSection: false,
};

export default DropdownSection;
